class APIS {
	apis() {
		return {
			getCustomerJourney: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/journey'
			},
			getCustomerReadableJourney: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/journey/readable'
			},
			getCustomerJourneyStats: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/journey/stats'
			},
			getCustomerListWithJourney: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/journey/customers'
			},
		};
	}
}

export default new APIS();
